import { Field, Form, Formik } from "formik";
import React, { useContext, useRef } from "react";
import { FormContext } from "../../../App";
import * as yup from "yup";
import {
  Container,
  Paper
} from "@mui/material";
import { styled } from "@mui/system";
import PostService from "utility/postService";
import DataLayerService from "utility/dataLayerService";
import TermAndCondition from "components/atoms/TermAndCondition";
import PhoneNumberInput from "components/atoms/PhoneNumberInput";
import Validation from "utility/validation";
import { getactiveTestScriptAP, scrollToTop, modalScrollToTop } from '../../../utility/functions';
import SMSMarketingCampaignComponent from "components/atoms/SMSMarketingCampaign";

// Import SVG Icons.
import { LeafButton } from "components/atoms/LeafButtons";
import { useProduct, useReCaptchaScore } from "hooks";
import ReCAPTCHA from "react-google-recaptcha";

const PhoneNumber = (props) => {
  const location = props.dataSet?.location ? props.dataSet.location : "multi-step-modal-form";
  const form = props.dataSet?.form ? props.dataSet.form : "modal";
  const selfScheduler = props.dataSet?.selfscheduler ? props.dataSet.selfscheduler : 'disable';
  const country = useProduct();
  const activeProspectTestScript = getactiveTestScriptAP();
  let errorMsg = "";
  let captchaScore = null;
  const formRef = useRef(null);
  const formHeader = props.dataSet?.formheader ? props.dataSet.formheader : "Get a FREE Estimate for a LeafFilter Gutter Guard System";

  // Disabling recaptcha.
  const reCaptchaShow = process.env.PANTHEON_ENVIRONMENT === 'live' ? (process.env.REACT_APP_RECAPTCHA_SHOW_PROD === 'enable') : (process.env.REACT_APP_RECAPTCHA_SHOW_NON_PROD === 'enable');
  const { activeStepIndex, setActiveStepIndex, formData } =
    useContext(FormContext);

  let phoneNumber = '';
  const ValidationSchema = yup.object().shape({
    phoneNumber: yup
      .string()
      .matches(/^\(\d{3}\) \d{3}-\d{4}$/, "Phone Number is not valid.")
      .required("Phone Number is required."),
  });

  const buttonSubmit = (e) => {

    // Validation Error.
    const phoneValidation = Validation.PhoneDataLayerValidation(phoneNumber);

    if (Object.keys(phoneValidation).length !== 0) {
      DataLayerService.formFailEvent(form, location, phoneValidation);

      modalScrollToTop(props.modalComponent);
    }

    // Scroll to the Top.
    scrollToTop(formRef);
  }

  const prevStep = () => {
    setActiveStepIndex(activeStepIndex - 1);
  };

  const handleOnBlur = (event) => {
    switch (event.target.name) {
      case 'phoneNumber':
        phoneNumber = event.target.value;
        break;

      default:
        break;
    }

    // Passing lf.form.interaction event to DataLayer.
    DataLayerService.formInteractionEvent(form, location);
  };

  const recaptchaRef = useRef();
  const reCaptchaScoreConstant = useReCaptchaScore();

  const StyledFormContainer = styled(Paper)(({ theme }) => ({
    background: "#ffffff",
    padding: `${theme.spacing(2)}`,
    borderRadius: 8,
    width: "100%",
    height: "auto",
  }));

  return (
    <Formik
      initialValues={{
        phoneNumber: formData.phoneNumber || '',
        trustedCertURL: document.getElementsByName("xxTrustedFormCertUrl")[0]
        ? document.getElementsByName("xxTrustedFormCertUrl")[0].value
        : "",
      }}
      validationSchema={ValidationSchema}
      onSubmit={async (values, actions) => {

        // Validate if the user is not a Robot.
        let captchaValue = '';
        const RecaptchaVerification = await Validation.RecaptchaVerification();
        captchaScore = RecaptchaVerification.score;

        if (captchaScore < reCaptchaScoreConstant) {
          captchaValue = recaptchaRef.current.getValue();
        }
        else {
          captchaValue = RecaptchaVerification.token;
        }

        if (captchaValue || !reCaptchaShow) {
          const data = { ...formData, ...values };
          let comments = "Landing Page:" + window.location.href +
            "\nTrusted Form URL:" + values.trustedCertURL +
            "\nRecaptcha Score:" + captchaScore;

          if (formData.rentown) {
            comments += '\nRent Own:' + formData.rentown;
          }

          if (formData.homelevel) {
            comments += '\nHome Level:' + formData.homelevel;
          }

          if (formData.requestedcompletion) {
            comments += '\nRequested Completion:' + formData.requestedcompletion;
          }

          let submittedValue = {
            'web_lead_source': "",
            'country': country,
            'emailAddress': formData.emailAddress,
            'firstName': formData.firstName,
            'fullName': formData.firstName + " " + formData.lastName,
            'lastName': formData.lastName,
            'phoneNumber': values.phoneNumber,
            'zipCode': formData.zipCode,
            'landing_page': window.location.origin + window.location.pathname,
            'source': '',
            'comments': comments,
            'recaptcha_token': captchaValue,
            'recaptcha_score': captchaScore,
            'QualifiedLead': false,
            'FirstName': formData.firstName,
            'LastName': formData.lastName,
            'Email': formData.emailAddress,
            'Phone': values.phoneNumber,
            'Zip': formData.zipCode,
            'WebEventDetail': '',
            'LeadSourceId': 1,
            'LeadSource': '41',
            'Notes': '',
          }

          if (selfScheduler === 'enable') {
            submittedValue = {
              ...submittedValue,
              ...{'utm_content': 'ss-delay'}
            }
          }

          if (activeProspectTestScript === 'nosandbox') {

            const certificateInformation = {
              'certificateLink': values.trustedCertURL,
              'userEmail': formData.emailAddress,
              'userPhone': values.phoneNumber,
            }

            try {
              const response = await PostService.retainCertificate('retain-cert', certificateInformation);
              console.log(response);
            } catch (error) {
              console.log(error);
              console.log("Error in retaining the Certificate.");
            }
          }


          try {
            const response = await PostService.postData('estimate', submittedValue, true);
            if (response.success) {
              setActiveStepIndex(activeStepIndex + 1);

              // Scroll to the Top.
              scrollToTop(formRef);

              // Passing lf.form.success event to DataLayer.
              DataLayerService.formSuccessEvent(form, 'estimate', location);

              // Passing lf.form.start event to DataLayer.
              DataLayerService.formStartEvent(form, location, data);

              localStorage.removeItem("zipCode");
            }
            else {
              errorMsg = "Sorry, there was an error during submission. Please try again.";
              actions.setSubmitting(false);
            }
          } catch (error) {
            console.log(error);
            console.log("Error in sending data");
          }
        }
      }}
    >
      {({ handleSubmit, setFieldValue, values, isSubmitting, errors }) => (
        <Container maxWidth={"sm"} disableGutters={true}>
          <StyledFormContainer>
            <Form
              className="flex flex-col justify-center items-start"
              onSubmit={handleSubmit}
              ref={formRef}
              onBlur={
                (event) => { handleOnBlur(event) }
              }
            >
              {Object.keys(errors).length > 0 && scrollToTop(formRef)}
              <h3 className="fw-semibold c--dark-charcoal">
                { formHeader }
              </h3>
              <div className="flex flex-col items-start mb-2">
                {errorMsg ? (<div className="border border-danger border-1 p-2 mb-4 error-msg fw-normal">{errorMsg}</div>) : ""}
                <PhoneNumberInput fieldName={'phoneNumber'} />
              </div>

              <SMSMarketingCampaignComponent />
              <Field type="hidden" name="trustedCertURL" />

              {reCaptchaShow && (
                <div className="recaptcha">
                  {captchaScore !== null && captchaScore < reCaptchaScoreConstant && (
                    <>
                      <ReCAPTCHA
                        ref={recaptchaRef}
                        size="normal"
                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY_V2}
                      />
                      <p className="error-msgs">reCAPTCHA verification failed. Please try again.</p>
                    </>
                  )}
                </div>
              )}

              <LeafButton
                buttonType={"primary"}
                type="submit"
                name="submit"
                handleClick={buttonSubmit}
                isSubmitting ={isSubmitting}
                style={{
                  width: "100%"
                }}>
                {isSubmitting ? ("Submitting") : ("Get Estimate")}
              </LeafButton>

              <div className="back-button">
                <LeafButton buttonType={"secondary"} onClick={prevStep}>
                  Back
                </LeafButton>
              </div>

              <TermAndCondition />
            </Form>
          </StyledFormContainer>
        </Container>
      )}
    </Formik>
  );
}

export default PhoneNumber;
